var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86666 0.999674C7.86666 0.631485 7.56818 0.333008 7.19999 0.333008C6.8318 0.333008 6.53333 0.631485 6.53333 0.999674V7.3902L4.33806 5.19494C4.07771 4.93459 3.6556 4.93459 3.39525 5.19494C3.1349 5.45529 3.1349 5.8774 3.39525 6.13775L6.72859 9.47108C6.98894 9.73143 7.41105 9.73143 7.6714 9.47108L11.0047 6.13775C11.2651 5.8774 11.2651 5.45529 11.0047 5.19494C10.7444 4.93459 10.3223 4.93459 10.0619 5.19494L7.86666 7.3902V0.999674Z",
    fill: "black",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19999 8.33301C1.56818 8.33301 1.86666 8.63148 1.86666 8.99967V11.6663C1.86666 11.8432 1.9369 12.0127 2.06192 12.1377C2.18694 12.2628 2.35651 12.333 2.53333 12.333H11.8667C12.0435 12.333 12.213 12.2628 12.3381 12.1377C12.4631 12.0127 12.5333 11.8432 12.5333 11.6663V8.99967C12.5333 8.63148 12.8318 8.33301 13.2 8.33301C13.5682 8.33301 13.8667 8.63148 13.8667 8.99967V11.6663C13.8667 12.1968 13.6559 12.7055 13.2809 13.0806C12.9058 13.4556 12.3971 13.6663 11.8667 13.6663H2.53333C2.00289 13.6663 1.49418 13.4556 1.11911 13.0806C0.744039 12.7055 0.533325 12.1968 0.533325 11.6663V8.99967C0.533325 8.63148 0.831802 8.33301 1.19999 8.33301Z",
    fill: "black",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.da398961fa2c6e13d48c45e1cd2eed2c.svg";
export { ForwardRef as ReactComponent };